import { useEffect, useState } from "react";
import "./GuestUserList.scss"
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { API_RESPONSE, DIALOG_CONSTANT, NUMBER_CONSTANTS, TOASTER_CONFIGS } from "../../../Utilities/Constants/Constants";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Pagination, Tooltip } from "@mui/material";
import { t } from "i18next";
import NoProducts from "../../../Shared/NoProducts/NoProducts";
import { checkEmpty } from "../../../Services/Helpers/Helper";
import view from "../../../../Assets/global/view.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import HttpsIcon from "@mui/icons-material/Https";
import ReasonDialog from "../../../Shared/ReasonDialog/ReasonDialog";
import { toast } from "react-toastify";

const GuestUsersList = () => {
  const navigate = useNavigate();
  const [GuestUserList, setGuestUsersList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalCount] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(10);
  const [hasProducts, setHasProducts] = useState(API_RESPONSE.FALSE);
  const [dialogOpenStatus, setDialogOpenStatus] = useState(false);

  const filtereddates: any = useSelector((state: any) => {
    return state.filterDatesReducer.filterdates
  })
  const [blockId, setBlockId] = useState<any>("")
  const dialogTitle = DIALOG_CONSTANT.BLOCK;

  // admin-record 
useEffect(() => {
  console.log("pathh", window.location?.pathname)
  const pathName = window.location?.pathname;
  const payload = {
    record_area: pathName.slice(1)
  }
  axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
    console.log(response)
  }).catch(() => {
  })
}, [])

  useEffect(() => {
    getGuestUsersList();
  }, [page, rowPerPage]);

  /**Handle row per page change */
  const onRowChange = (event: any) => {
    setPage(NUMBER_CONSTANTS.ONE);
    setRowPerPage(parseInt(event.target.value));
  };

  /* Handle page change */
  const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
    setPage(newPage);
  };

  const guestUserListPayload = () => {
    return {
      page: page,
      limit: rowPerPage,
      start_date: filtereddates?.filter_date?.start_date || "",
      end_date: filtereddates?.filter_date?.end_date || "",
    }
  }

  const getGuestUsersList = () => {
    axiosInstance
      .post(API_END_POINTS.GUEST_USER_LIST, guestUserListPayload())
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          setGuestUsersList(response.data.result.data);
          setTotalCount(response.data.result.total_page);
          setHasProducts(checkEmpty(response.data.result.data));
        }
      }).catch(() => {

      });
  };
  const onCloseDialog = () => {
    setDialogOpenStatus(false)
  }

  const onSubmitReason = (value: any) => {
    const payload = {
      id: blockId,
      block_type: "GuestUser",
      reason: value?.reason,
    }

    axiosInstance.put(API_END_POINTS.BLOCK_USER_LIST, null, { params: payload }).then((respones: any) => {
      if (respones?.status) {
        toast.success(respones.data.message, TOASTER_CONFIGS);
        setDialogOpenStatus(false)
        getGuestUsersList();
      }


    }).catch(() => {

    })
  }

  const handleUnblock = (id:any) => {
    const payload = {
      id: id,
      block_type: "GuestUser",
      reason: ""
    }
    if (id) {
      axiosInstance.put(API_END_POINTS.BLOCK_USER_LIST, null, { params: payload }).then((respones: any) => {
        if (respones?.status) {
          toast.success(respones.data.message, TOASTER_CONFIGS);
          getGuestUsersList();
        }
      }).catch(() => {

      })
    }

  }

  return (<div className="admin-list-wrapper">
    <div className="table-wrapper">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("S.NO")}</TableCell>
              <TableCell>{t("First Name")}</TableCell>
              <TableCell>{t("Last Name")}</TableCell>
              <TableCell>{t("Email")}</TableCell>
              <TableCell>{t("Phone Number")}</TableCell>
              <TableCell>{t("Actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hasProducts && GuestUserList?.map((universityDataElement: any, index: any) => {
              return (
                <>
                  <TableRow key={index + 1}>
                    <TableCell>
                      {page - 1 === 0
                        ? index + 1
                        : (page - 1) * rowPerPage + (index + 1)}
                    </TableCell>
                    <TableCell>
                      {universityDataElement.firstname}
                    </TableCell>
                    <TableCell>
                      {universityDataElement.lastname}
                    </TableCell>
                    <TableCell>
                      {universityDataElement.email}
                    </TableCell>
                    <TableCell>
                      {universityDataElement.phone_number ? universityDataElement.phone_number : 'N/A'}
                    </TableCell>
                    <TableCell>
                      <div className="action_wrap">
                        <Tooltip
                          title={t("View User")}
                          placement="bottom"
                        >
                          <img
                            onClick={() => {
                              navigate(`/manage-guest-users/${universityDataElement.id}`);
                            }}
                            className="view_edit_icons"
                            src={view}
                            alt="Learn and Play"
                          />
                        </Tooltip>
                        {universityDataElement?.is_block ? (
                          <div
                            className="reject_btn_wrapper"
                            onClick={() => {
                              // setBlockId(universityDataElement.id);
                              handleUnblock(universityDataElement.id)
                            }}
                          >
                            <div className="accept_btn_label">
                              {t("Unblock")}
                            </div>
                            <div className="lock_icon_wrapper">
                              <HttpsIcon className="lock_icon" />
                            </div>
                          </div>) :
                          <div
                            className="accept_btn_wrapper"
                            onClick={() => {
                              setBlockId(universityDataElement.id);
                              setDialogOpenStatus(true)
                            }}
                          >
                            <div className="unlock_icon_wrapper">
                              <LockOpenTwoToneIcon className="unlock_icon" />
                            </div>
                            <div className="accept_btn_label">
                              {t("Block")}
                            </div>
                          </div>
                        }
                      </div>

                    </TableCell>

                  </TableRow>
                </>
              )
            })}


          </TableBody>

        </Table>
        {!hasProducts && <NoProducts />}
      </TableContainer>
      {hasProducts && (
        <div className="tablePagination">
          <div className="row">
            <div className="col-md-7">
              <div className="pagination-wrap">
                <Pagination
                  count={totalPage}
                  page={page}
                  onChange={handleChangePage}
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="rows-per-page">
                <p>{t("Rows per page")}:</p>
                <select
                  className="rows-select"
                  value={rowPerPage}
                  onChange={onRowChange}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    <ReasonDialog
      modalState={dialogOpenStatus}
      dialogStatus={onCloseDialog}
      submitReason={onSubmitReason}
      title={dialogTitle}
    />
  </div>
  )
};

export default GuestUsersList;
